import { createContext, useContext, useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import { completeSchedulingTask, fetchJourneyTodos } from 'modules/api/common';
import { isEmpty } from 'lodash';
import { getEnv } from 'modules/api/utils';
import env from 'environments';

const JourneyContext = createContext(null);

export function JourneyContextProvider({ children }) {
  const [initialTodo, setTodo] = useState([]);

  // hubspot-off-block-3 task 93: with the Welcome Journey disconnected the
  // query never runs, so the context stays empty (todos []) and no request
  // reaches the afy-welcome-journey service.
  const { data: todos, refetch, isLoading } = useQuery(
    'fetchJourneyTodos',
    () => fetchJourneyTodos(),
    { enabled: !env.WELCOME_JOURNEY_DISABLED },
  );

  useEffect(() => {
    if (env.WELCOME_JOURNEY_DISABLED) return;
    // With HubSpot Meetings off the member completes the scheduling task with
    // the "I booked my call — continue" button; auto-completing it here would
    // hide whether that button works (hubspot-off-block-3 task 64, rehearsal R1).
    if (env.HUBSPOT_MEETINGS_DISABLED) return;
    const environment = getEnv();
    const completeTask = async () => {
      if (environment === 'development' || environment === 'staging') {
        try {
          await completeSchedulingTask();
        } catch (error) {
          console.error('Error completing scheduling task:', error);
        }
      }
    };
    completeTask();
  }, []);

  useEffect(() => {
    if (!isEmpty(todos)) {
      setTodo(todos.data);
    }
  }, [todos]);

  return (
    <JourneyContext.Provider
      value={{
        todos: initialTodo,
        refetchTodos: refetch,
        isLoadingTodos: isLoading,
      }}
    >
      {children}
    </JourneyContext.Provider>
  );
}

export function useTodoJourney() {
  const context = useContext(JourneyContext);
  if (context === undefined) {
    throw new Error('Context must be used within a Provider');
  }
  return context;
}
